'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CarouselSection2 = require('./../carousel/CarouselSection');

var _ShopifySection = require('./../ShopifySection');

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTAINER_SELECTOR = '[data-uspbar-carousel-container]'; /*
                                                              *  USP Bar Scripts
                                                              *
                                                              *
                                                              *  Version:
                                                              *    1.0.0 - 2020/07/08
                                                              */

var CAROUSEL_SELECTOR = '[data-uspbar-carousel]';

var USPBar = function (_CarouselSection) {
  (0, _inherits3.default)(USPBar, _CarouselSection);

  function USPBar(container) {
    (0, _classCallCheck3.default)(this, USPBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (USPBar.__proto__ || Object.getPrototypeOf(USPBar)).call(this, container));

    _this.carouselSelector = container.find(CAROUSEL_SELECTOR);

    _this.autoplaySpeed = 3000;
    if (container.attr('data-autoplay-speed').length) {
      _this.autoplaySpeed = container.attr('data-autoplay-speed');
    }

    _this.slickInit = false;

    _this.container.on('unslick', CAROUSEL_SELECTOR, function () {
      return _this.onUnslick();
    });
    $(window).on('resize orientationchange', function () {
      return _this.onResize();
    });
    _this.onResize();
    return _this;
  }

  (0, _createClass3.default)(USPBar, [{
    key: 'optionOverrides',
    value: function optionOverrides() {
      return {
        autoplay: true,
        autoplaySpeed: this.autoplaySpeed,
        arrows: true,
        dots: false,
        responsive: [{
          breakpoint: ResponsiveSizes.small - 1,
          settings: { slidesToShow: 1 }
        }, {
          breakpoint: ResponsiveSizes.medium - 1,
          settings: 'unslick'
        }]
      };
    }
  }, {
    key: 'onUnslick',
    value: function onUnslick() {
      this.slickInit = false;
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      if (this.slickInit) return;
      var windowWidth = $(window).width();

      if (windowWidth < ResponsiveSizes.medium && !this.slickInit) {
        this.slick = this.initCarousel(this.carouselSelector);
        this.slickInit = true;
      } else if (windowWidth >= ResponsiveSizes.medium) {
        this.slickInit = false;
      }
    }
  }]);
  return USPBar;
}(_CarouselSection2.CarouselSection);

(0, _ShopifySection.register)(CONTAINER_SELECTOR, USPBar);